<span>{{ placeholder ? placeholder : ('cart.sortLabels.sortBy' | cxTranslate) }}</span>
<div class="sort-table-container d-inline-block" display="dynamic" [placement]="getPlacement()" ngbDropdown>
  <button class="btn btn-link ml-2 p-0 shadow-none" [ngClass]="activeLanguage" id="sortDropdown" ngbDropdownToggle>
    {{ useSelectedOptionAsLabel ? selectedOption : sortLabels ? sortLabels[selectedOption] : '' }}
    <mat-icon class="material-icons-sharp light md-12 ml-1">expand_more</mat-icon>
  </button>
  <div
    ngbDropdownMenu
    aria-labelledby="sortDropdown"
    class="dropdown-menu dropdown-menu-right border-0"
    [style.width.px]="sortWidth ? sortWidth : ''"
  >
    @for (sort of sortOptions; track sort) {
    <button
      class="js-sort"
      ngbDropdownItem
      [class.selected]="sort.code === selectedOption"
      (click)="sortList(sort.code)"
    >
      @if (sort.code === selectedOption) {
      <mat-icon svgIcon="check" class="md-12 mr-1"></mat-icon>
      }{{ sort.name ? sort.name : sortLabels ? sortLabels[sort.code] : '' }}
    </button>
    }
  </div>
</div>
